export enum UserStatus {
  Active = 'Активен',
  Blocked = 'Заблокирован',
  Deleted = 'Удалён',
}

export interface TLoginApiResponse {
  jsonWebToken: string;
  refreshToken: string;
  jsonWebTokenExpiresAt: string;
  refreshTokenExpiresAt: string;
}

export interface TLoginUser {
  login: string;
  password: string;
}

export interface TUserWalletBalances {
  rp: number;
  score: number;
  patch: number;
  ticket: number;
}

export interface TUser {
  id: number | string;
  singleStatisticId: number;
  username?: string;
  gender?: string;
  language?: string;
  isOnboardingCompleted?: boolean;
  email?: string;
  role?: 'SUPERADMIN' | 'ADMINISTRATOR' | 'MODERATOR' | 'USER';
  status?: UserStatus;
  lastActivityDate?: Date;
  IsBanned?: boolean;
  walletBalances?: TUserWalletBalances;
}
